import React from 'react';

export function GoogleCalendarIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#4285F4"/>
      <path d="M15 0h4a5 5 0 015 5v4h-9V0z" fill="#1967D2"/>
      <rect x="15" y="9" width="9" height="9" fill="#FBBC04"/>
      <path d="M0 19v0a5 5 0 005 5h10v-6H0v1z" fill="#34A853"/>
      <path d="M15 18v6h4a5 5 0 005-5v-1h-9z" fill="#EA4335"/>
      <rect x="3" y="3" width="13" height="18" rx="1.5" fill="white"/>
      <rect x="6" y="11" width="7" height="1.5" rx="0.75" fill="#4285F4"/>
      <rect x="6" y="14" width="5" height="1.5" rx="0.75" fill="#4285F4"/>
      <rect x="6" y="7.5" width="4" height="1.5" rx="0.75" fill="#BDBDBD"/>
      <rect x="11.5" y="7" width="1.5" height="2.5" rx="0.75" fill="#BDBDBD"/>
      <rect x="6.5" y="7" width="1.5" height="2.5" rx="0.75" fill="#BDBDBD"/>
    </svg>
  );
}

export function AppleCalendarIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#fff" stroke="#e0e0e0" strokeWidth="1"/>
      <rect x="0" y="0" width="24" height="7" rx="5" fill="#FF3B30"/>
      <rect x="0" y="4" width="24" height="3" fill="#FF3B30"/>
      <text x="12" y="18" textAnchor="middle" fill="#1C1C1E" fontFamily="-apple-system, sans-serif" fontSize="9" fontWeight="700">CAL</text>
      <text x="12" y="10.5" textAnchor="middle" fill="#fff" fontFamily="-apple-system, sans-serif" fontSize="5.5" fontWeight="500">APR</text>
    </svg>
  );
}

export function MicrosoftCalendarIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#0078D4"/>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2" fill="white"/>
      <rect x="2.5" y="4.5" width="19" height="5.5" fill="#0078D4"/>
      <rect x="7.5" y="3" width="1.5" height="3" rx="0.75" fill="white"/>
      <rect x="15" y="3" width="1.5" height="3" rx="0.75" fill="white"/>
      <rect x="5" y="12" width="4" height="1.5" rx="0.75" fill="#0078D4"/>
      <rect x="10" y="12" width="4" height="1.5" rx="0.75" fill="#0078D4"/>
      <rect x="15" y="12" width="4" height="1.5" rx="0.75" fill="#0078D4"/>
      <rect x="5" y="15" width="4" height="1.5" rx="0.75" fill="#0078D4"/>
      <rect x="10" y="15" width="4" height="1.5" rx="0.75" fill="#0078D4"/>
    </svg>
  );
}

export function BookmarkIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-bm-a)">
        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 2.43945V12.4195C17 14.3895 15.59 15.1595 13.86 14.1195L12.54 13.3295C12.24 13.1495 11.76 13.1495 11.46 13.3295L10.14 14.1195C8.41 15.1495 7 14.3895 7 12.4195V2.43945" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs><clipPath id="clip-bm-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}

export function PencilIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-pen-a)">
        <path d="M13.26 3.59924L5.04997 12.2892C4.73997 12.6192 4.43997 13.2692 4.37997 13.7192L4.00997 16.9592C3.87997 18.1292 4.71997 18.9292 5.87997 18.7292L9.09997 18.1792C9.54997 18.0992 10.18 17.7692 10.49 17.4292L18.7 8.73924C20.12 7.23924 20.76 5.52924 18.55 3.43924C16.35 1.36924 14.68 2.09924 13.26 3.59924Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.89 5.05078C12.32 7.81078 14.56 9.92078 17.34 10.2008" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 22H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs><clipPath id="clip-pen-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}

export function TrashIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-tr-a)">
        <path d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.85 9.14062L18.2 19.2106C18.09 20.7806 18 22.0006 15.21 22.0006H8.79002C6.00002 22.0006 5.91002 20.7806 5.80002 19.2106L5.15002 9.14062" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.33 16.5H13.66" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.5 12.5H14.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs><clipPath id="clip-tr-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}

export function AngefertigtIcon({ size = 24, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-ang-a)">
        <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill={color}/>
        <path d="M18 15.25C17.59 15.25 17.25 14.91 17.25 14.5C17.25 13.81 16.69 13.25 16 13.25H8C7.31 13.25 6.75 13.81 6.75 14.5C6.75 14.91 6.41 15.25 6 15.25C5.59 15.25 5.25 14.91 5.25 14.5V7.75C5.25 6.23 6.48 5 8 5H16C17.52 5 18.75 6.23 18.75 7.75V14.5C18.75 14.91 18.41 15.25 18 15.25Z" fill={color}/>
        <path d="M12 19C10.47 19 9.18003 17.93 8.84003 16.5H6C5.59 16.5 5.25 16.16 5.25 15.75V14.5C5.25 12.98 6.48 11.75 8 11.75H16C17.52 11.75 18.75 12.98 18.75 14.5V15.75C18.75 16.16 18.41 16.5 18 16.5H15.16C14.82 17.93 13.53 19 12 19Z" fill={color}/>
      </g>
      <defs><clipPath id="clip-ang-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}

export function AbgeschicktIcon({ size = 24, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-abg-a)">
        <path d="M9.51002 4.23062L18.07 8.51062C21.91 10.4306 21.91 13.5706 18.07 15.4906L9.51002 19.7706C3.75002 22.6506 1.40002 20.2906 4.28002 14.5406L5.15002 12.8106C5.37002 12.3706 5.37002 11.6406 5.15002 11.2006L4.28002 9.46062C1.40002 3.71062 3.76002 1.35062 9.51002 4.23062Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.43994 12H10.8399" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs><clipPath id="clip-abg-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}

export function InterviewIcon({ size = 24, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5002 14.9902L15.4902 20.0102" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.5 14.9902H20.5" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.5 9.01023L8.51 3.99023" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.5 9.00977H3.5" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function ZusageIcon({ size = 24, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.75 12L10.58 14.83L16.25 9.17" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function AbsageIcon({ size = 24, color = '#000000' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-abs-a)">
        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.17004 14.8299L14.83 9.16992" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.83 14.8299L9.17004 9.16992" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs><clipPath id="clip-abs-a"><rect width="24" height="24" fill="white"/></clipPath></defs>
    </svg>
  );
}


export function StarSVG({ filled, size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? '#FFBC00' : 'none'} style={{ flexShrink: 0 }}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        stroke={filled ? '#FFBC00' : 'currentColor'} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function EditSVG({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function ChevronSVG({ up, size = 14, opacity = 0.4, color, textColor = '#1C1A16' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0, opacity }}>
      {up
        ? <path d="M3 9l4-4 4 4" stroke={color || textColor} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        : <path d="M3 5l4 4 4-4" stroke={color || textColor} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      }
    </svg>
  );
}

export function PersonSVG({ size = 15, color = '#7D776F' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <circle cx="8" cy="5" r="2.4" stroke={color} strokeWidth="1.4"/>
      <path d="M2.5 14c0-2.485 2.462-4.5 5.5-4.5s5.5 2.015 5.5 4.5" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
}

export function CalendarSVG({ size = 15, color = '#7D776F' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <rect x="1.5" y="3" width="13" height="11" rx="2" stroke={color} strokeWidth="1.4"/>
      <path d="M5 1.5v3M11 1.5v3M1.5 7h13" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
}

export function EuroSVG({ size = 15, color = '#7D776F' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <path d="M12 4.5A5 5 0 108 13.5" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M3 7.5h7M3 9.5h7" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  );
}

export function DotsMenuSVG({ size = 14, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <circle cx="4" cy="8" r="1.4" fill={color}/>
      <circle cx="8" cy="8" r="1.4" fill={color}/>
      <circle cx="12" cy="8" r="1.4" fill={color}/>
    </svg>
  );
}
